module.exports = __webpack_public_path__ + "static/media/fasad13.7a6bada2.jpeg";